
import { Challenge } from '../../types/game';
import { skills } from '../skills';

export const talentShortageChallenge: Challenge = {
  id: 'talent-shortage',
  title: 'Industry Talent Shortage',
  description: 'Qualified personnel are becoming increasingly difficult to recruit and retain.',
  options: [
    {
      text: 'Implement comprehensive training program',
      outcome: 'You successfully developed talent in-house, creating a loyal and skilled team.',
      kpiEffects: {
        profitMargin: -2,
        efficiency: 3,
        uptime: 2
      },
      experienceGain: 35,
      skillUnlock: skills.find(s => s.id === 'team-management')
    },
    {
      text: 'Offer premium compensation packages',
      outcome: 'You attracted top talent by outbidding competitors, but at significant cost.',
      kpiEffects: {
        efficiency: 5,
        uptime: 4,
        profitMargin: -5
      },
      experienceGain: 30
    },
    {
      text: 'Automate more processes',
      outcome: 'You reduced reliance on personnel through increased automation.',
      kpiEffects: {
        efficiency: 4,
        uptime: -1,
        profitMargin: -3,
        energyCost: 0.01
      },
      experienceGain: 40,
      skillUnlock: skills.find(s => s.id === 'advanced-diagnostics')
    }
  ],
  difficulty: 4,
  requiredSkills: ['team-management']
}
